/**
 * Закрытие модалки кликом по затемнению — одним обработчиком на весь сайт.
 *
 * У нативного `<dialog>` фон ::backdrop принадлежит самому элементу, поэтому
 * клик мимо окна приходит на него. Прежде каждая модалка заводила свой
 * `closeOnBackdrop`, и половина из них про него забывала.
 */
export function installDialogDismiss() {
  document.addEventListener("click", (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;

    // Клик внутри окна всплывает от содержимого, а не от самого <dialog>.
    dialog.close();
  });
}
